// extracted by mini-css-extract-plugin
export default {"button":"EditTabButton_button__qnmpk","image":"EditTabButton_image__n2tY0","iconPremium":"EditTabButton_iconPremium__hOgeW","disabled":"EditTabButton_disabled__zNHUk"};